import { ReactNode } from 'react';
import { AuthProvider } from './auth';
import { SidebarAndModalProvider } from './sidebarAndModal';
import { ThemeProvider } from './theme';
import { LanguageProvider } from './language';
import { ApolloProvider } from './apollo';
import { GeometryProvider } from './geometry';

type GlobalContextProps = {
  children: ReactNode;
};

export const ContextApiProviders = ({ children }: GlobalContextProps) => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ApolloProvider>
          <LanguageProvider>
            <SidebarAndModalProvider>
              <GeometryProvider>{children}</GeometryProvider>
            </SidebarAndModalProvider>
          </LanguageProvider>
        </ApolloProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};
